export default __webpack_public_path__ + "static/media/MapPopup.52b4829e.png";